import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { useCashbackModals } from '@hooks/modals/useCashbackModals';
import { useTranslation } from 'react-i18next';
import Button from '@components/common/button';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useUserContext } from '@hooks/context/useUserContext';
import { useLocales } from '@hooks/helpers/useLocales';
import { Icon } from '@components/icons';

const Cashback = () => {
    const { t } = useTranslation('sections', {
        keyPrefix: 'dashboard.cashback'
    });
    const { handleOpenCashbackModal } = useCashbackModals();
    const { cashback } = useUserContext();
    const navigate = useNavigate();
    const { submitLocale } = useLocales();

    return (
        <div className={styles.cashback_wrapper}>
            <div className={styles.header}>
                <Typography variant="h5">{t('title')}</Typography>
                <Button
                    variant="text-gray"
                    leftIcon="external_link"
                    iconSize={18}
                    onClick={() => window.open('https://xeppt.com/cashback', '_blank')}
                    className={styles.link}>
                    Get started
                </Button>
            </div>
            <div className={styles.cashback_content}>
                <div className={styles.info}>
                    <Icon name="gift" />
                    <Typography variant="body4">{t('amount')}</Typography>
                </div>
                <Typography variant="body3" weight="semibold">
                    ${cashback?.available.toFixed(2)}
                </Typography>
            </div>
            <div
                className={`${styles.footer_wrapper} ${(cashback?.available || 0) >= 5 ? styles.isAvailable : ''}`}>
                <div className={styles.actions}>
                    {(cashback?.available || 0) >= 5 ? (
                        <Button
                            variant="gold"
                            size="medium"
                            leftIcon="arrow_down"
                            onClick={handleOpenCashbackModal}>
                            {submitLocale('redeem')}
                        </Button>
                    ) : (
                        <Typography variant="body4">
                            <b>${(5 - (cashback?.available || 0)).toFixed(2)}</b> left to accumulate
                            to withdraw cashback
                        </Typography>
                    )}
                    <Button
                        variant={(cashback?.available || 0) < 5 ? 'gold' : 'text-gray'}
                        size={(cashback?.available || 0) < 5 ? 'medium' : undefined}
                        onClick={() => navigate(routes.cashback_history)}
                        className={styles.link}>
                        {submitLocale('my_cashback')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Cashback;
